import React from 'react';
import { Card, Typography, Space } from 'antd';
import styles from './StagePlaceholder.module.scss';

const { Title, Paragraph } = Typography;

export interface StagePlaceholderProps {
  stageNumber: number;
  title: string;
  description: string;
  planningType?: 'sales' | 'purchase';
}

export const StagePlaceholder: React.FC<StagePlaceholderProps> = ({
  stageNumber,
  title,
  description,
}) => {
  return (
    <div className={styles.pageContainer}>
      <Card className={styles.centerCard}>
        <Space orientation="vertical" size="large" className={styles.contentSpace}>
          <div className={styles.constructionIcon}>
            🚧
          </div>

          <Title level={3} className={styles.title}>
            Этап {stageNumber}: {title}
          </Title>

          <Paragraph className={styles.description}>
            {description}
          </Paragraph>
        </Space>
      </Card>
    </div>
  );
};


